import React from "react";
import * as LocaleManager from "../../logic/LocaleManager";

// Externals
//import cn from "classnames";

//Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appStateActions from "redux/actions/appStateActions";

// DevExtreme components
import DropDownButton from 'devextreme-react/drop-down-button';

// Component styles
import classes from "./LoginHeader.module.scss";

function LoginHeader(props) {
  const { currentUILanguageCode } = props;

  const onLocaleValueChanged = (args) => {
    let id = args.item.id;
    props.appStateActions.setUILanguage(id);
    props.appStateActions.setDataViewLanguage(id);
  };

  return (
    <div className={classes.header}>
      <div>
        <DropDownButton
          stylingMode="text"
          focusStateEnabled={false}
          useSelectMode={true}
          selectedItemKey={currentUILanguageCode}
          dataSource={LocaleManager.getAvailableLocales()}
          displayExpr="text"
          keyExpr="id"
          onSelectionChanged={onLocaleValueChanged}
        />
      </div>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginHeader);

